import DashboardView from './Dashboard.view';
import withNavBar from 'src/hocs/withNavBar.hoc';
import withHelmet from 'src/hocs/withHelmet';
import { compose } from 'ramda';
import withProps from 'src/hocs/withProps';
import { withCookies } from 'react-cookie';
import { t } from 'src/i18n';
import withDashboardProvider from 'src/hocs/withDashboardProvider.hoc';

const enhance = compose(
  withProps({ title: t('general.title.dashboard') }),
  withHelmet,
  withCookies,
  withNavBar,
  withDashboardProvider,
);

export default enhance(DashboardView);
